module.exports = __webpack_public_path__ + "static/media/available-apple-store.e374ae72.svg";